module.exports = __webpack_public_path__ + "img/settings.f26113ac.svg";